import { render, staticRenderFns } from "./TopoInterno.vue?vue&type=template&id=52a0c77a&scoped=true&"
import script from "./TopoInterno.vue?vue&type=script&lang=js&"
export * from "./TopoInterno.vue?vue&type=script&lang=js&"
import style0 from "./TopoInterno.vue?vue&type=style&index=0&id=52a0c77a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a0c77a",
  null
  
)

export default component.exports